<template>
  <div class="flex items-start mb-4 pb-4 border-b-2">
    <div class="md:w-4/5 flex flex-col">
      <div class="flex flex-col mb-3">
        <span class="text-left pb-2 uppercase text-sm tracking-wider">Pregunta</span>
        <input
          :class="{'border-red-500': question.error}"
          class="bg-gray-200 appearance-none border-2 border-blue-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-blue-300"
          type="text"
          v-model="question.value"
        />
        <p v-if="question.error" class="text-red-500 text-xs italic text-left">Ingrese la pregunta.</p>
      </div>
      <div class="flex flex-wrap -mx-3 mb-0">
        <div class="w-5/12 px-3 mb-6 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs mb-2 text-left"
            for="icon"
          >Tipo</label>
          <div class="relative mb-3">
            <select
              :class="{'border-red-500': question.optionError}"
              class="block appearance-none w-full bg-gray-200 border-2 border-blue-500 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-blue-300"
              name="icon"
              v-model="question.fileType"
            >
              <option value="photo">Foto</option>
              <option value="video">Vídeo</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
          <p
            v-if="question.optionError"
            class="ml-3 mt-2 text-red-500 text-xs italic text-left"
          >Deben seleccionar al menos una opción.</p>
        </div>
        <!-- <div class="flex items-center px-3 mb-6 md:mb-0">
          <label class="flex justify-start items-start px-2 pt-2">
            <div
              class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500"
            >
              <input type="checkbox" class="hidden" v-model="question.photo" />
              <svg
                class="fill-current hidden w-4 h-4 text-green-500 pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none">Foto</div>
          </label>
          <label class="flex justify-start items-start px-2 pt-2">
            <div
              class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500"
            >
              <input type="checkbox" class="hidden" v-model="question.video" />
              <svg
                class="fill-current hidden w-4 h-4 text-green-500 pointer-events-none"
                viewBox="0 0 20 20"
              >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
              </svg>
            </div>
            <div class="select-none">Video</div>
          </label>
          <p
            v-if="question.optionError"
            class="ml-3 mt-2 text-red-500 text-xs italic text-left"
          >Deben seleccionar al menos una opción.</p>
        </div>-->
      </div>
    </div>
    <div class="md:w-1/5 flex justify-center">
      <button
        type="button"
        class="flex items-center px-2 py-1 rounded bg-red-500 text-gray-100 hover:bg-red-700"
        @click="remove"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "multimedia-question",
  methods: {
    remove() {
      this.$emit("click");
    }
  },
  props: {
    question: {
      required: true
    }
  }
};
</script>

<style scoped>
input:checked + svg {
  display: block;
}
</style>